//Sets dimensions
var points = [];

var imageWidth = 398;
var imageHeight = 1310;

var stairsWidth = 30,
    stairsHeight = 940,
    numStairs = 86,
    flightHeight = stairsHeight / numStairs,
    stairsLeft = ( imageWidth - stairsWidth ) / 2,
    stairsRight = ( imageWidth + stairsWidth ) / 2,
    currentY = imageHeight - 17;

//For loop, start at 0 count to <86 (86 times), increment by 1
for(var i = 0; i < numStairs; i++) {
  // points.push([
  //   i % 2 ? stairsLeft : stairsRight,
  //   currentY
  // ]);
  // currentY -= flightHeight;
  points.push([
    stairsLeft,
    currentY
  ], [
    stairsRight,
    currentY -= flightHeight
  ])
}

var times = {
  crake: 5730,
  mayr: 6830,
  gottlieb: 9810
};

var elements = document.querySelectorAll( '.gia-chart' );

var remaining;

function pad ( str, digits ) {
  str = String( str );
  while ( str.length < digits ) str = '0' + str;
  return str;
}

function play () {
  remaining = elements.length;

  function render ( el ) {
    var id = el.getAttribute( 'data-id' );
    var duration = times[ id ];

    var path = el.querySelector( 'path' );
    var d = 'M' + points
      .map( function ( point ) {
        return point[0] + ',' + point[1]
      })
      .join( ' ' );

    path.setAttribute( 'd', d );
    var length = path.getTotalLength();

    var timer = el.querySelector( '.timer' );

    var start = Date.now();

    function loop () {
      var elapsed = Math.min( Date.now() - start, duration );

      var t = quadOut( elapsed / duration );

      // TODO update timer here
      var milliseconds = elapsed * 100;
      var realtime = milliseconds / 1e3;
      var seconds = Math.round( realtime % 60 );
      var minutes = ~~( realtime / 60 );

      var time = pad( minutes, 2 ) + ':' + pad( seconds, 2 );
      timer.textContent = time;

      var solid = t * length;
      var remaining = length - solid;
      var dashArray = solid + ',' + remaining;
      path.setAttribute( 'stroke-dasharray', dashArray );

      if ( elapsed < duration ) {
        requestAnimationFrame( loop );
      } else {
        check();
      }
    }

    loop();
  }

  for ( var i = 0; i < elements.length; i += 1 ) {
    render( elements[i] );
  }
}

function check () {
  remaining -= 1;
  if ( remaining <= 0 ) {

    setTimeout( function () {
      play();
    }, 2500 );
  }
}

play();

function quadOut(t) {
  return -t * (t - 2.0)
}
